import React, { useContext, useEffect } from "react";
import { BroadcastContext } from "../context/BroadcastContext"; // Make sure this path and context are correct

const MessageCounter = () => {
  const { unreadCount, fetchUnreadCount } = useContext(BroadcastContext);

  // Fetch count when component mounts
  useEffect(() => {
    // Make sure fetchUnreadCount is defined in your BroadcastContext
    if (fetchUnreadCount) {
        fetchUnreadCount();
    }
  }, [fetchUnreadCount]);

  if (!unreadCount || unreadCount <= 0) return null;

  return (
    <span className="ml-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
      {unreadCount}
    </span>
  );
};

export default MessageCounter;